import { Component, OnInit, Inject, Input, Output } from '@angular/core';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { SelectedAssuranceComponent } from '../selected-assurance/selected-assurance.component';


import { AddtypeinsuranceComponent } from '../addtypeinsurance/addtypeinsurance.component';

import { AddbigcategComponent } from '../addbigcateg/addbigcateg.component';

import { AddgarantieComponent } from '../addgarantie/addgarantie.component';

import { CustomParameterComponent } from '../custom-parameter/custom-parameter.component';


import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ViewChild, TemplateRef } from '@angular/core';


export interface Parametre {
  nomFrmt : string; 
  type : "simple" ;
  intitule: string;
}

export interface Garantie {
  nomFrmt : string; 
  intitule: string;
  params: Parametre[];
  formule: any[];
  mandatory :  boolean ;
}

export interface Categorie {
  nomFrmt : string; 
  intitule: string;
  garanties: Garantie[]
}

export interface Insurance {
  nomFrmt : string; 
  intitule: string;
  policy: boolean ;
  categs: Categorie[]
}



@Component({
  selector: 'app-parametrage',
  templateUrl: './parametrage.component.html',
  styleUrls: ['./parametrage.component.css']
})
export class ParametrageComponent implements OnInit {

  rcTabval  = 0 ;
  dtTabval  = 0 ;
  vlTabval  = 0 ;
  incTabval = 0 ;
  bglTabval = 0 ;
  srTabval  = 0 ;


  retourClientWS  : ReponseWebService ;

  activeChoice = 0 ;

  selectedValue = "" ;

  newcateg = "" ;

  createnewcatg = 0 ;

  addsaveicon = "add" ;

  currentInsuranceCategs = [] ;

  currentCateg = "" ;
  currentCategConfig = "" ;

  currentInsurance = "" ;
  globalInsuranceConfig = "" ;

  canAdd = false ;

  addPrm = 0 ;

  choosencompagnieID = 0 ;

  choosencompagnieName = "" ;

  primarycolor = "primary" ;//"#3f51b5" ;

  newGarantie = "" ;

  lesAssurances = [] ;
  lesCategsParAssurance = [] ;


  allInsurancesTypes =  [] ;// [{"intitule": "Assurance Auto", "icon":"iconeassuranceauto"}] ;

  choosenInsuranceType : any ;

  allBigCategories = [] ; /*[{"idcateg": "1", "categorie": "CAT 1", "denommintation":"TOURISME", 
                        "abreviation":"VPCI", 
                        "description":"VEHICULE PERSONNEL POUR USAGE PERSONNEL",
                        "soustypes":["BERLINE", "CAMIONNETTE", "PICK-UPS", "REMORQUE"]}] ;*/

  choosenBigCateg : any ;

  allGaranties = [] ;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isEditable = false;

  primeParams = [] ;
  nomsPrimes = [] ;
  configPrimes = [] ;
  primesOpt = [] ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;


  allTheCompagnies: any ;

  theCurrentCompagnie : any ;

  vientDechooseCompagnie = 1 ;

  allInsurances = [] ;
  currentCategGaranties = [] ;
  choosedInsuranceIndex = -1 ;
  choosedCategoryIndex = -1 ;

  allCompagnies = [] ;

  constructor(public dialog: MatDialog,  private configServer: ServicepoolService) {}

  ngOnInit(): void {
    this.getAllCompagnies() ;    
    this.getAllInsuranceTypes() ;    
  }


  getAllCompagnies(){

    console.log("Here we go !!!") ;

    
    this.configServer.getAllCompagnies("thiswii").then( (retourbi) => {

      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allTheCompagnies = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  getAllInsuranceTypes(){

    console.log("Here we go 148 !!! ") ;
    this.configServer.getAllInsuranceTypes("thiswii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allInsurancesTypes = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }



  getAllBigCategories(){

    this.openSpinnerDialog();
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllBigCategories("thiswii", this.choosenInsuranceType.raniee).then( (retourbi) => {
    
    this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allBigCategories = this.retourClientWS.data ; 

      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  getAllPossibleGarantiesGLobalFunc(){

    console.log("Here we go 187 !!! ") ;
    //Le second paramètre this.choosenBigCateg.idcateg de la fonction ci-dessous ne sert plus et a été remmplacé par une valeur fixe 
    //qui ne porte en soi aucun sens mais permet juste d'eviter certain effet pervers et ne pas avoir à reparcourir un trop long code pour des mises à jour
    this.configServer.getAllPossibleGarantiesGLobalFunc("thiswii", this.choosenInsuranceType.raniee,   "this.choosenBigCateg.idcateg").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("DoneGarantiesCALL") ;
        this.allGaranties = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }



  taneBenCompagnie(oneidComp, indexcompagnie){
    this.choosencompagnieID = oneidComp ;
    this.choosencompagnieName = this.allTheCompagnies[indexcompagnie].nomcompagnie ;
    this.vientDechooseCompagnie = 1 ;
    this.activeChoice = 0 ;

    this.theCurrentCompagnie = {"id":this.choosencompagnieID, "name":this.choosencompagnieName} ;

    this.canAdd = false ;     
    this.currentInsuranceCategs = [] ;
    this.choosedInsuranceIndex = -1 ;

    this.choosenInsuranceType = undefined ;
  }


  soppiMbirrMi(domaine){

  	if (domaine=="rc")
	  	this.rcTabval = (this.rcTabval==1)? 0:1 ;
  	if (domaine=='dt')
	  	this.dtTabval = (this.dtTabval==1)? 0:1 ;
  	if (domaine=='vl')
	  	this.vlTabval = (this.vlTabval==1)? 0:1 ;
  	if (domaine=='inc')
	  	this.incTabval = (this.incTabval==1)? 0:1 ;
  	if (domaine=='bgl')
	  	this.bglTabval = (this.bglTabval==1)? 0:1 ;
  	if (domaine=='sr')
	  	this.srTabval = (this.srTabval==1)? 0:1 ;
  }



  ajouterPrime(){
    this.openDialogNewGarantie() ;
  }



  openDialogNewGarantie(){
    var data = {"nomgarantie": this.newGarantie, "typeassurance": this.choosenInsuranceType} ;

    const dialogRef = this.dialog.open(AddgarantieComponent, {data, disableClose: true});
    
    dialogRef.afterClosed().subscribe(result => {

      if(result.length >= 2 ){
        this.newGarantie = result ;
        //var newLength = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.push({"nomFrmt": this.formatThisString(this.newGarantie), "intitule": this.newGarantie, "params": [{"nomFrmt":"Franchise", "intitule": "Franchise"}], "formule": [], "mandatory": false }) ;
        var newLength = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.push({"nomFrmt": this.formatThisString(this.newGarantie), "intitule": this.newGarantie, "params": [], "formule": [], "mandatory": false }) ;
        sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
        this.getAllPossibleGarantiesGLobalFunc() ;         
      }

      this.newGarantie = "" ;
    });
  }




  weShallRemoveThis(eventValue, index){

    var closureOrder = JSON.parse(eventValue).ordre ;

    console.log(JSON.parse(eventValue) ) ;
    console.log("(((((((((((index)))))))))))") ;
    console.log(index) ;

    if( JSON.parse(eventValue).ordre == "fermer"){
      console.log("Là pour fermer") ;
      this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.splice(index, 1)  ;
    }else{
      this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties[index] = JSON.parse(eventValue).garantie ;
      sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
      console.log(this.allInsurances) ;      
    }
  }

  selectedOrCreateAssurance(event){
    console.log(this.selectedValue) ;
    this.activeChoice = 0 ;
    if(event.value!="-"){
      if(event.value=="new001one"){
        this.canAdd = false ;     
        this.currentInsuranceCategs = [] ;
        this.choosedInsuranceIndex = -1 ;
        this.openDialogNewAssurance(-1) ;
      }
      else{
        this.canAdd = true ;     
        console.log("117") ;
        this.currentInsurance = this.lesAssurances[event.value] ;
        console.log("120") ;
        //this.currentInsuranceCategs  =  this.lesCategsParAssurance[event.value] ;              
        this.currentInsuranceCategs = this.allInsurances[event.value].categs ;
        console.log("122") ;
        this.choosedInsuranceIndex = event.value ;
        this.openDialogNewAssurance(event.value) ;        
      }
    }else{
        this.choosedInsuranceIndex = -1 ;
        this.canAdd = false ;     
        this.currentInsuranceCategs = [] ;      
    }
  }



  prePutBigCategSoustypesAsCateg(){
    let soustypes  = [] ;
    for (var i = 0; i < this.choosenBigCateg.soustypes.length; i++) {
      soustypes.push({"nomFrmt":this.formatThisString(this.choosenBigCateg.soustypes[i]), "intitule":this.choosenBigCateg.soustypes[i], "garanties": []} ) ;
    }

    return soustypes ;
  }



  openDialogNewAssurance(indice){

    var data : any ;

    let infosup = JSON.stringify({"idcompagnie":this.choosencompagnieID, "nomcompagnie":this.choosencompagnieName});

    if(indice==-1)
     data = {"infosup": infosup, "assurName": "",  "policy":false, "categs": this.prePutBigCategSoustypesAsCateg(), "typeassurance":this.choosenInsuranceType, "bigcategorie": this.choosenBigCateg } ;
     //data = {"infosup": infosup, "assurName": "",  "policy":false, "categs": [{"nomFrmt":this.formatThisString("Aucune Distinction"), "intitule":"Aucune Distinction", "garanties": []}] } ;
    else
     data = {"infosup": infosup, "assurName": this.allInsurances[indice].intitule, "policy":this.allInsurances[indice].policy, "categs": this.allInsurances[indice].categs, "typeassurance":this.choosenInsuranceType, "bigcategorie":this.choosenBigCateg } ;

    const dialogRef = this.dialog.open(SelectedAssuranceComponent, {data});
    
    dialogRef.afterClosed().subscribe(result => {

      var retourDialog =  {"nomassurance": "", "categs": [], "policy":false} ;

      if ( result==undefined || result==""  )
          retourDialog = {"nomassurance": data.assurName, "categs": data.categs, "policy":retourDialog.policy } ;
      else
          retourDialog = JSON.parse(result) ;

      if(retourDialog.nomassurance!=""){
        if(retourDialog.nomassurance!="*"){
          if(indice==-1){
            this.allInsurances.push({"nomFrmt": this.formatThisString(retourDialog.nomassurance), "intitule": retourDialog.nomassurance, "policy":retourDialog.policy, "categs": retourDialog.categs }) ;
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
          }else{
            console.log("167") ;
            this.allInsurances[this.choosedInsuranceIndex].nomFrmt = this.formatThisString(retourDialog.nomassurance) ;
            this.allInsurances[this.choosedInsuranceIndex].intitule = retourDialog.nomassurance  ;
            this.allInsurances[this.choosedInsuranceIndex].policy = retourDialog.policy  ;
            this.allInsurances[this.choosedInsuranceIndex].categs = retourDialog.categs ;
            this.canAdd = true ;                        
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
            console.log("173") ;
          }
        }
        else{
          if(indice!=-1){

            this.allInsurances.splice(this.choosedInsuranceIndex, 1)  ;
            this.choosedInsuranceIndex = -1 ;
            sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
          }
        }
      }
    });
  }



  addorSavenewCateg(){
    if(this.createnewcatg==0){
      this.createnewcatg = 1 ;
      this.addsaveicon = "done" ;
    }else{
      if(this.newcateg!="")
        this.currentInsuranceCategs.push(this.newcateg) ;

      this.newcateg = "" ;
      this.createnewcatg = 0 ;
      this.addsaveicon = "add" ;      
    }
  }

  formatThisString(name){

    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }

  getCategsFrom(categsNames){
    var returnedValues = [] ;
    for (var i = 0 ; i <categsNames.length; i++) {
      var aCategorie = {"nomFrmt":this.formatThisString(categsNames[i]), "intitule": categsNames[i], "garanties": []} ;
      returnedValues.push(aCategorie) ;
    }

    return returnedValues ;
  }

  configEnsForcateg(index){
    this.currentCateg =  this.currentInsuranceCategs[index].intitule ;    
    this.currentCategGaranties = this.currentInsuranceCategs[index].garanties ;
    this.choosedCategoryIndex = index ;
    this.activeChoice = 1 ;
  }



  sauvegarderAssurance(){  

    var nomassurance = this.allInsurances[this.choosedInsuranceIndex].nomFrmt ;
    var configToSave = JSON.stringify(this.allInsurances[this.choosedInsuranceIndex]) ;

    console.log(this.allInsurances[this.choosedInsuranceIndex]) ;

    var data = {"title": "Enregistrement Information", "message": "Voulez-vous vraiment enregistrer cette configuration ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){

        let infosup = JSON.stringify({"idcompagnie":this.choosencompagnieID, 
                                        "nomcompagnie":this.choosencompagnieName, 
                                          "idcategorie":this.choosenBigCateg.idcateg});

        this.openSpinnerDialog();

        this.configServer.updateConfig("1111", configToSave, nomassurance, infosup).then( (retourbi) => {

          this.closeSpinnerDialog() ;
            this.retourClientWS = retourbi ;
            var statutrec = this.retourClientWS.statutreq ;
            var message = this.retourClientWS.message ;
            if(statutrec==1)
              console.log("Done") ;
            else
              console.log("Failed") ;
        }) ;        
      }
      else{
        console.log("") ;        
      }

    });

  }


  getAllConfigs(){  

    console.log(this.choosencompagnieID) ;

    this.openSpinnerDialog();

    this.configServer.getAllConfigs(this.choosencompagnieID, 
                                      this.choosenInsuranceType.raniee, 
                                        this.choosenBigCateg.idcateg).then( (retourbi) => {

      this.closeSpinnerDialog() ;
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        console.log(this.retourClientWS) ;
        this.allInsurances = [] ;

        if(statutrec==1){
          console.log("Done") ;
          var data = JSON.parse(this.retourClientWS.data) ;          
          for (var i = 0 ; i <data.length; i++) {
            this.allInsurances.push( JSON.parse(data[i].config) ) ;
          }
        }
        else
          console.log("Failed") ;
    }) ;    
  }


  getThePrimaryColor(idInCompagnie){
    let valuReturn = this.choosencompagnieID==idInCompagnie ? this.primarycolor:'' ;
    return valuReturn ;
  }


  openDialogNewInsuranceType(){
    var data : any ;
    data = this.allInsurancesTypes ;
    const dialogRef = this.dialog.open(AddtypeinsuranceComponent, {data, disableClose: true});
    
    dialogRef.afterClosed().subscribe(result => {
        this.getAllInsuranceTypes() ;
    });
  }



  openDialogNewBigCateg(){
    var data : any ;
    data = this.choosenInsuranceType ;
    const dialogRef = this.dialog.open(AddbigcategComponent, {data, disableClose: true});
    
    dialogRef.afterClosed().subscribe(result => {
        this.getAllBigCategories() ;
    });
  }



  choosedInSelectInsType(slctdInsType){
    if(slctdInsType=="new001one"){
      this.choosenInsuranceType = undefined ;
      this.openDialogNewInsuranceType() ;
    }
    else{
      this.choosenInsuranceType  = this.allInsurancesTypes[slctdInsType] ;
      this.getAllBigCategories() ;
      this.getAllPossibleGarantiesGLobalFunc();
      //this.getAllConfigs();
    }
  }



  choosedInSelectCateg(slctdInsType){
    if(slctdInsType=="new001one"){
      this.choosenBigCateg = undefined ;
      this.openDialogNewBigCateg() ;
    }
    else{
      this.choosenBigCateg  = this.allBigCategories[slctdInsType] ;
      this.getAllConfigs();
    }
  }



  choosedInSelectGarantie(slctd){
    this.newGarantie = this.allGaranties[slctd].nom ;
    var newLength = this.allInsurances[this.choosedInsuranceIndex].categs[this.choosedCategoryIndex].garanties.push({"nomFrmt": this.formatThisString(this.newGarantie), "intitule": this.newGarantie, "params": [/*{"nomFrmt":"Franchise", "intitule": "Franchise"}*/], "formule": [], "mandatory": false }) ;
    sessionStorage.setItem('allinsurances', JSON.stringify(this.allInsurances)) ;
  }


  choosedInSelect(slctd){
    
    this.activeChoice = 0 ;

    this.vientDechooseCompagnie = 0 ;

    if(slctd=="new001one"){
      this.canAdd = false ;     
      this.currentInsuranceCategs = [] ;
      this.choosedInsuranceIndex = -1 ;
      this.openDialogNewAssurance(-1) ;
    }
    else{
      if(slctd=="predefcustom"){
        this.openDialogNewPredefCustom() ;
      }else{
        this.canAdd = true ;     
        console.log("117") ;
        this.currentInsurance = this.lesAssurances[slctd] ;
        console.log("120") ;
        //this.currentInsuranceCategs  =  this.lesCategsParAssurance[event.value] ;              
        this.currentInsuranceCategs = this.allInsurances[slctd].categs ;
        console.log("122") ;
        this.choosedInsuranceIndex = slctd ;
        this.openDialogNewAssurance(slctd) ;                
      }
    }

  }


  openDialogNewPredefCustom(){

    const dialogRef = this.dialog.open(CustomParameterComponent, {});
    
    dialogRef.afterClosed().subscribe(result => {
      ;
    });
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}

